export default "/images/management.png?ac855f1b441740fce977dd5c40afdcb4";